import Scriba from 'react-scriba';
import AuthContext from '../configAuth/Auth';
import { Data } from '../data/Data';
import { DataCompte } from '../data/DataCompte';

export class Immocom {

    static chargementMonCompte(_this) {
        let chargementMonCompte = DataCompte._chargementMonCompte();

        chargementMonCompte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

                if (retourVerif === null) {
                    _this.setState({
                        monCompte: responseFetch.reponseAPIobjet
                    });
                }
                else {
                    Immocom.onTraitementErreurAvecState(_this, { ..._this.state }, retourVerif, responseFetch);
                }
            });
    }

    static onRegardeSiOnChargeLesDonnees(responsePromise, _this) {
        let tableauObjectsRetour = null;

        if (responsePromise.length > 0) {
            responsePromise.forEach(tableauObject => {
                if (tableauObjectsRetour == null) {
                    tableauObjectsRetour = Scriba.fetch().traitementRetour(tableauObject, _this, 100);

                    if (tableauObjectsRetour.hideMessageBarWarning & tableauObjectsRetour.hideMessageBarError)
                        tableauObjectsRetour = null;
                }
            });
        }
        else {
            tableauObjectsRetour = Scriba.fetch().traitementRetour(responsePromise, _this, 100);

            if (tableauObjectsRetour.hideMessageBarWarning & tableauObjectsRetour.hideMessageBarError)
                tableauObjectsRetour = null;
        }

        return tableauObjectsRetour;
    }

    // Similaire onRegardeSiOnChargeLesDonnees mais pour les functional components
    static checkFetchResponse = (responses, onSuccess, onError) => {
        // Si c'est un array alors on est dans le cas d'un Promise.all()
        if (!Array.isArray(responses)) responses = [responses];
        let result;
        const ok = responses.every(response => {
            result = Immocom.analyzeResponse(response);
            return result.hideMessageBarWarning && result.hideMessageBarError;
        });
        if (ok && typeof onSuccess === "function") return onSuccess();
        else if (typeof onError === "function") return onError(result);
    };

    // Similaire Scriba.fetch().traitementRetour mais pour les functional components
    static analyzeResponse = (response, codeLimiteErreur = 100) => {

        const { codeRetour, messageInfo, messageRetour } = response;

        let retour = {
            warningMessage: null,
            hideMessageBarWarning: true,
            errorMessage: null,
            hideMessageBarError: true,
        };

        if (0 < codeRetour && codeRetour < codeLimiteErreur) {
            retour.warningMessage = messageInfo;
            retour.hideMessageBarWarning = false;
        }
        else if (codeRetour >= codeLimiteErreur) {
            retour.errorMessage = messageRetour;
            retour.hideMessageBarError = false;
        }

        return retour;

    };

    static onChargementOptions(responseFetch, _this, stateTemp, nomStateDesOptionsAMettreAJour, nomKeyOption, nomValueOption, estEntier) {
        let options = [];

        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

        if (retourVerif === null) {
            this.chargementOptions(responseFetch.reponseAPIobjet, options, nomKeyOption, nomValueOption, true, estEntier);

            stateTemp[nomStateDesOptionsAMettreAJour] = options;
        }
        else {
            Immocom.onTraitementErreurAvecState(_this, stateTemp, retourVerif, responseFetch);
        }
    }

    static chargementOptions(data, tableauOptions, key, value, chargeValeurParDefaut, estEntier) {

        estEntier = (estEntier === undefined || estEntier == null ? true : estEntier);

        if (chargeValeurParDefaut)
            Immocom.ajoutValeurDefautDansOptionSansTest_Prop_avecValeurDefaut(tableauOptions, estEntier);

        if (data !== null && data !== undefined) {
            data.map(dataTrav => {
                tableauOptions.push({
                    key: dataTrav[key],
                    text: dataTrav[value]
                });
            });
        }
    }

    static ajoutValeurDefautDansOption(_this, options, idOption, text) {
        text = text || "Sélectionnez";
        if (_this.props.avecValeurDefaut)
            options.push({ key: idOption, text });
    };

    static ajoutValeurDefautDansOptionSansTest_Prop_avecValeurDefaut(opt, estEntier) {

        estEntier = (estEntier === undefined || estEntier == null ? true : estEntier);

        opt.push({
            key: (estEntier ? 0 : '0'),
            text: 'Sélectionnez'
        });
    }

    static onTraitementErreurAvecState(_this, state, retourVerif, responseFetch) {
        if (!retourVerif.hideMessageBarWarning) {
            state.enCoursDeTraitement = false;
            state.messageEnCoursTraitement = '';
            state.hideMessageBarWarning = false;
            state.warningMessage = retourVerif.warningMessage;
        }
        else {
            if (Immocom.estCodeErreurUtilisateurNonAuthentifie(responseFetch.codeRetour)) {
                Immocom.deconnexionEtRedirectionVersLogin();
            }
            else {
                state.enCoursDeTraitement = false;
                state.messageEnCoursTraitement = '';
                state.hideMessageBarError = false;
                state.errorMessage = retourVerif.errorMessage;
            }
        }
        _this.setState(state);
    }

    static notifieStatusHttpImmocom(responseFetch, _this) {
        let retourVerif = Scriba.fetch().traitementRetour(responseFetch, _this, 100);
        if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
            return {
                hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                warningMessage: retourVerif.warningMessage,
                hideMessageBarError: retourVerif.hideMessageBarError,
                errorMessage: retourVerif.errorMessage,
                hideMessageBarFiltres: (responseFetch.messageInfo === "" || responseFetch.messageInfo === null),
                messageMessageBarFiltres: responseFetch.messageInfo
            };

        } else {
            if (!retourVerif.hideMessageBarWarning) {
                return {
                    hideMessageBarWarning: false,
                    warningMessage: retourVerif.warningMessage
                }
            }
            else {
                if (Immocom.estCodeErreurUtilisateurNonAuthentifie(responseFetch.codeRetour)) {
                    Immocom.deconnexionEtRedirectionVersLogin();
                }
                else {
                    return {
                        hideMessageBarError: false,
                        errorMessage: retourVerif.errorMessage
                    }
                }
            }
        }

        return {}
    }

    static onTraitementErreurPromise(_this, retourVerif) {
        if (!retourVerif.hideMessageBarWarning) {
            _this.setState({
                enCoursDeTraitement: false,
                messageEnCoursTraitement: '',
                hideMessageBarWarning: false,
                warningMessage: retourVerif.warningMessage
            });
        }
        else {
            _this.setState({
                enCoursDeTraitement: false,
                messageEnCoursTraitement: '',
                hideMessageBarError: false,
                errorMessage: retourVerif.errorMessage
            });
        }
    }

    static onReinitStateValeurParDefaut(state) {
        state.enCoursDeTraitement = false;
        state.messageEnCoursTraitement = '';

        state.hideMessageBarWarning = true;
        state.warningMessage = '';
        state.hideMessageBarError = true;
        state.errorMessage = '';
    }

    static onReinitStateValeurParDefautEtExecutionDuSetState(_this, state, onReinitialiseLesValeursParDefaut, callback) {
        if ((Immocom.getSiPropsRenseignee(onReinitialiseLesValeursParDefaut) && onReinitialiseLesValeursParDefaut) || !Immocom.getSiPropsRenseignee(onReinitialiseLesValeursParDefaut))
            this.onReinitStateValeurParDefaut(state);

        if (callback != undefined)
            _this.setState(state, callback);
        else
            _this.setState(state);
    }

    static onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(_this, state, callback) {
        this.onReinitStateValeurParDefaut(state);

        if (callback != undefined)
            _this.setState(state, callback);
        else
            _this.setState(state);
    }

    static getIconeEnFonctionDeLExtension(nomDocument) {
        var extension = nomDocument.substr((nomDocument.lastIndexOf('.') + 1));
        var nomIcone = "";

        if (extension === "doc" || extension === "docx")
            nomIcone = "WordDocument";
        else if (extension === "pdf" || extension === "PDF")
            nomIcone = "PDF";
        else if (extension === "xls" || extension === "xlsx")
            nomIcone = "ExcelDocument";
        else if (extension === "jpeg" || extension === "jpg" || extension === "bmp" || extension === "gif" || extension === "png")
            nomIcone = "Photo2";
        else
            nomIcone = "TextDocument";

        return nomIcone;
    }

    static deconnexionEtRedirectionVersLogin() {
        // On supprime toute trace de connexion puis on redirge vers la page de login
        sessionStorage.clear();
        localStorage.clear();
        AuthContext.logOut();

        document.location.href = "/";
    }

    static estCodeErreurUtilisateurNonAuthentifie(codeRetour) {
        return (codeRetour === 200);
    }

    static getSiPropsRenseignee(props) {
        return (props !== undefined && props != null);
    }

    static getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(props, tableauValeurDoitEtreDifferent) {
        let estDifferent = true;

        if (tableauValeurDoitEtreDifferent.length > 0)
            for (let i = 0; estDifferent && (i < tableauValeurDoitEtreDifferent.length); i++)
                estDifferent = (props !== tableauValeurDoitEtreDifferent[i]);

        return (this.getSiPropsRenseignee(props) && estDifferent);
    }

    static getBadgeStatutOperation(statut) {
        let classBadge = null;

        switch (statut) {
            case "Livrée":
                classBadge = "success";
                break;
            case "Montage":
                classBadge = "warning";
                break;
            case "Haute":
                classBadge = "danger";
                break;
            case "Actable":
                classBadge = "primary";
                break;
            case "Non actable":
                classBadge = "info";
                break;
            case "Archivée":
                classBadge = "light";
                break;
            case "Hors commercialisation Eiffage":
                classBadge = "dark";
                break;
            default:
                classBadge = "secondary";
                break;
        }

        return classBadge;
    }

    //MG - 25/05/2023 - 2335/2239
    static calculationHonoraireReel(honorairesCommercialisationParam, baseCalculHonoraireCommercialisationParam, prixTTCLot, prixHT) {
        if (honorairesCommercialisationParam === null) return;
        const lastChar = honorairesCommercialisationParam.slice(-1);
        let honoraireReel = 0;
        let percentageHonoraire = 0;

        const honorairesCommercialisation = parseFloat(honorairesCommercialisationParam.replace(',', '.'));

        if (lastChar === '%') {
            if (baseCalculHonoraireCommercialisationParam === 'HT sur TTC' || baseCalculHonoraireCommercialisationParam === 'TTC sur TTC') {
                honoraireReel = (prixTTCLot * honorairesCommercialisation) / 100;
                percentageHonoraire = (honoraireReel / prixTTCLot) * 100;
            } else if (baseCalculHonoraireCommercialisationParam === 'HT sur HT') {
                honoraireReel = (prixHT * honorairesCommercialisation) / 100;
                percentageHonoraire = (honoraireReel / prixHT) * 100;
            }
        } else if (lastChar === '€') {
            honoraireReel = honorairesCommercialisation;

            if (baseCalculHonoraireCommercialisationParam === 'HT sur TTC' || baseCalculHonoraireCommercialisationParam === 'TTC sur TTC') {
                percentageHonoraire = (honoraireReel / prixTTCLot) * 100;
            } else if (baseCalculHonoraireCommercialisationParam === 'HT sur HT') {
                percentageHonoraire = (honoraireReel / prixHT) * 100;
            }
        }

        return {
            honoraireReel: honoraireReel,
            percentageHonoraire: percentageHonoraire
        };
    }

    static getBadgeCycleOperation(idCycle) {
        let classBadge = null;

        switch (idCycle) {
            case 1:
                classBadge = "light";
                break;
            case 2:
                classBadge = "info";
                break;
            case 3:
                classBadge = "primary";
                break;
            case 6:
                classBadge = "warning";
                break;
            case 7:
                classBadge = "danger";
                break;
            case 8:
                classBadge = "success";
                break;
            case 10:
                classBadge = "dark";
                break;
            default:
                classBadge = "secondary";
                break;
        }

        return classBadge;
    }

    static getNavigateur() {
        const userAgentNavigateur = navigator.userAgent;
        let navigateur = "";

        if (userAgentNavigateur.indexOf("Firefox") > -1) {
            navigateur = "Firefox";
        } else if (userAgentNavigateur.indexOf("SamsungBrowser") > -1) {
            navigateur = "Samsung Internet";
        } else if (userAgentNavigateur.indexOf("Opera") > -1 || userAgentNavigateur.indexOf("OPR") > -1) {
            navigateur = "Opera";
        } else if (userAgentNavigateur.indexOf("Trident") > -1) {
            navigateur = "Internet Explorer";
        } else if (userAgentNavigateur.indexOf("Edge") > -1) {
            navigateur = "Edge";
        } else if (userAgentNavigateur.indexOf("Chrome") > -1) {
            navigateur = "Chrome";
        } else if (userAgentNavigateur.indexOf("Safari") > -1) {
            navigateur = "Safari";
        } else {
            navigateur = "Inconnu";
        }

        return navigateur;
    }

    static conversion() {
        return Immocom_Conversion;
    }

    static perimetre() {
        return Immocom_Perimetre;
    }

    static liste() {
        return Immocom_Liste;
    }

    static fiche() {
        return Immocom_Fiche;
    }
}

//class de méthodes utilisées dans FicheTache et FicheTicket
class Immocom_Perimetre {

    static _onChangeChoiceGroupPerimetreEiffage = (_this, nomObjet, ev, option, callBack) => {
        if (option.key === "national") {
            let objetTrav = { ..._this.state[nomObjet] };
            objetTrav.perimetreNational = true;
            objetTrav.idRegion = 0;
            objetTrav.idAgence = 0;
            objetTrav.idOperation = 0;
            objetTrav.idRegionAdministrative = 0;
            objetTrav.idDepartementAdministratif = '0';
            objetTrav.idVilleAdministrative = '0';

            if (callBack !== undefined)
                _this.setState({
                    [nomObjet]: objetTrav,
                    affichagePerimetreNational: true,
                    affichagePerimetreEiffage: false,
                    affichagePerimetreAdministratif: false
                }, callBack);
            else
                _this.setState({
                    [nomObjet]: objetTrav,
                    affichagePerimetreNational: true,
                    affichagePerimetreEiffage: false,
                    affichagePerimetreAdministratif: false
                });
        }
        else if (option.key === "eiffage") {
            let objetTrav = { ..._this.state[nomObjet] };
            objetTrav.perimetreNational = false;
            objetTrav.idRegion = 0;
            objetTrav.idAgence = 0;
            objetTrav.idOperation = 0;
            objetTrav.idRegionAdministrative = 0;
            objetTrav.idDepartementAdministratif = '0';
            objetTrav.idVilleAdministrative = '0';

            if (callBack !== undefined)
                _this.setState({
                    [nomObjet]: objetTrav,
                    affichagePerimetreNational: false,
                    affichagePerimetreEiffage: true,
                    affichagePerimetreAdministratif: false
                }, callBack);
            else
                _this.setState({
                    [nomObjet]: objetTrav,
                    affichagePerimetreNational: false,
                    affichagePerimetreEiffage: true,
                    affichagePerimetreAdministratif: false
                });
        }
        else {
            let objetTrav = { ..._this.state[nomObjet] };
            objetTrav.perimetreNational = false;
            objetTrav.idRegion = 0;
            objetTrav.idAgence = 0;
            objetTrav.idOperation = 0;
            objetTrav.idRegionAdministrative = 0;
            objetTrav.idDepartementAdministratif = '0';
            objetTrav.idVilleAdministrative = '0';

            if (callBack !== undefined)
                _this.setState({
                    [nomObjet]: objetTrav,
                    affichagePerimetreNational: false,
                    affichagePerimetreEiffage: false,
                    affichagePerimetreAdministratif: true
                }, callBack);
            else
                _this.setState({
                    [nomObjet]: objetTrav,
                    affichagePerimetreNational: false,
                    affichagePerimetreEiffage: false,
                    affichagePerimetreAdministratif: true
                });
        }
    }

}

class Immocom_Liste {
    static _chargementDonnees = (_this, url, objet) => {
        if (!_this.state.enCoursDeTraitement) {
            _this.setState({
                enCoursDeTraitement: true
            });

            var paramPost = Scriba.fetch().createParameterPost(objet);

            fetch(url, paramPost)
                .then(response => response.json())
                .then(data => {
                    let retourVerif = Scriba.fetch().traitementRetour(data, _this);

                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        //let listeItem = data.reponseAPIobjet;
                        //YD : 17/06/2020 : Ajout test sur listeItem != null
                        let listeItem = (data.reponseAPIobjet !== null ? data.reponseAPIobjet : []);

                        _this.setState({
                            items: listeItem,
                            enCoursDeTraitement: false,
                            hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                            warningMessage: retourVerif.warningMessage,
                            hideMessageBarError: retourVerif.hideMessageBarError,
                            errorMessage: retourVerif.errorMessage,
                            hideMessageBarFiltres: (data.messageInfo === "" || data.messageInfo === null),
                            messageMessageBarFiltres: data.messageInfo
                        });
                    }
                    else {
                        _this.setState({
                            items: [],
                            enCoursDeTraitement: false,
                            hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                            warningMessage: retourVerif.warningMessage,
                            hideMessageBarError: retourVerif.hideMessageBarError,
                            errorMessage: retourVerif.errorMessage,
                            hideMessageBarFiltres: (data.messageInfo === "" || data.messageInfo === null),
                            messageMessageBarFiltres: data.messageInfo
                        });

                    }
                });
        }

    }
}

class Immocom_Fiche {
    static _validationFormulaire(_this, nomClass, item, typeEnregistrement) {
        let estValide = false;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            //let typeEnregistrement = (item.idContact > 0 ? 'Modification' : 'Création');
            var validationFormulaire = Data._onValidationFormulaire(nomClass, item, typeEnregistrement);

            validationFormulaire
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

                    if (retourVerif !== null) {
                        estValide = false;
                    }
                    else {
                        estValide = true;
                    }

                    if (responseFetch.codeRetour == "099") {
                        _this.setState({ onActiveBoutonEnregistrer: estValide, errorMessage: responseFetch.messageRetour });
                    }
                    else {
                        _this.setState({ onActiveBoutonEnregistrer: estValide, errorMessage: '' });
                    }

                });
        }
        else {
            _this.setState({ onActiveBoutonEnregistrer: estValide });
        }
    }
    static _validationSurSortieDeChamp(_this, nomClass, item, typeEnregistrement) {
        let estValide = false;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            //let typeEnregistrement = (item.idContact > 0 ? 'Modification' : 'Création');
            var validationFormulaire = Data._onValidationFormulaire(nomClass, item, typeEnregistrement);

            validationFormulaire
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

                    if (retourVerif !== null) {
                        estValide = false;

                        Immocom.onTraitementErreurAvecState(_this, { ..._this.state }, retourVerif, responseFetch);
                    }
                    else {
                        estValide = true;
                    }

                    _this.setState({ onActiveBoutonEnregistrer: estValide });
                });
        }
        else {
            _this.setState({ onActiveBoutonEnregistrer: estValide });
        }
    }

    //static _validationFormulaire2(_this, nomClass, nomPropriete, item, typeEnregistrement) {
    //    let estValide = false;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        //let typeEnregistrement = (item.idContact > 0 ? 'Modification' : 'Création');
    //        var validationFormulaire = Data._onValidationFormulaire(nomClass, item, typeEnregistrement);

    //        validationFormulaire
    //            .then(responseFetch => {
    //                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

    //                if (retourVerif !== null) {
    //                    estValide = false;
    //                }
    //                else {
    //                    estValide = true;
    //                }

    //                _this.setState({ [nomPropriete]: estValide });
    //            });
    //    }
    //    else {
    //        _this.setState({ [nomPropriete]: estValide });
    //    }
    //}


    static getNbCarRestants = (str, nbCarMax) => {
        const nbCar = (str || "").length;
        return Math.max(nbCarMax - nbCar, 0);
    };
}

class Immocom_Conversion {
    static nombreEnToutesLettres = (nombreAConvertir) => {
        if (nombreAConvertir !== undefined && nombreAConvertir !== null) {
            // Inspiré de https://openclassrooms.com/forum/sujet/convertir-chiffre-en-lettre-63922
            var res, plus, diz, s, un, mil, mil2, ent, deci, centi, pl, pl2, conj;
            var t = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
            var t2 = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
            var t3 = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];

            // traitement des deux parties du nombre;
            function decint(n) {

                switch (n.length) {
                    case 1: return dix(n);
                    case 2: return dix(n);
                    case 3: return cent(n.charAt(0)) + (n.charAt(0) != "0" && n.substring(1) == "00" ? "s" : "") + " " + decint(n.substring(1));
                    default: mil = n.substring(0, n.length - 3);
                        if (mil.length < 4) {
                            un = (mil == 1) ? "" : decint(mil);
                            return un + mille(mil) + " " + decint(n.substring(mil.length));
                        }
                        else {
                            mil2 = mil.substring(0, mil.length - 3);
                            return decint(mil2) + million(mil2) + " " + decint(n.substring(mil2.length));
                        }
                }
            }

            // traitement des nombres entre 0 et 99, pour chaque tranche de 3 chiffres
            function dix(n) {
                if (n < 10) {
                    return t[parseInt(n)]
                }
                else if (n > 9 && n < 20) {
                    return t2[n.charAt(1)]
                }
                else {
                    plus = n.charAt(1) == 0 && n.charAt(0) != 7 && n.charAt(0) != 9 ? "" : (n.charAt(1) == 1 && n.charAt(0) < 8) ? " et " : "-";
                    diz = n.charAt(0) == 7 || n.charAt(0) == 9 ? t2[n.charAt(1)] : t[n.charAt(1)];
                    s = n == 80 ? "s" : "";

                    return t3[n.charAt(0)] + s + plus + diz;
                }
            }

            // traitement des mots "cent", "mille" et "million"
            function cent(n) {
                return n > 1 ? t[n] + " cent" : (n == 1) ? " cent" : "";
            }

            function mille(n) {
                return n >= 1 ? " mille" : "";
            }

            function million(n) {
                return n > 1 ? " millions" : " million";
            }

            // conversion du nombre
            function transform(n) {
                n = n.replace(/ /g, "").replace("€", "");

                // vérification de la valeur saisie
                if (!/^\d+[.,]?\d*$/.test(n)) {
                    return "Nombre non valide."
                }

                // séparation entier + décimales
                n = n.replace(/(^0+)|(\.0+$)/g, "");
                n = n.replace(/([.,]\d{2})\d+/, "$1");

                let n1 = n.replace(/[,.]\d*/, "");
                let n2 = n1 != n ? n.replace(/\d*[,.]/, "") : false;

                // variables de mise en forme
                ent = !n1 ? "" : decint(n1);
                deci = !n2 ? "" : decint(n2);

                if (!n1 && !n2) {
                    return "zéro"
                }

                conj = (!n2 || n2 == "00") || !n1 ? "" : "  et ";
                let euro = !n1 ? "" : !/[23456789]00$/.test(n1) ? " euro" : " euro";
                centi = (!n2 || n2 == "00") ? "" : " centime";
                pl = n1 > 1 ? "s" : "";
                pl2 = n2 > 1 ? "s" : "";

                // expression complète en toutes lettres
                return (ent + euro + pl + conj + deci + centi + pl2).replace(/\s+/g, " ");
            }

            return transform(nombreAConvertir);
        }
        else {
            return null;
        }
    }

    static getMoisAPartirNumero = (numMois) => {
        switch (numMois) {
            case 1:
                return 'Janvier';
            case 2:
                return 'Février';
            case 3:
                return 'Mars';
            case 4:
                return 'Avril';
            case 5:
                return 'Mai';
            case 6:
                return 'Juin';
            case 7:
                return 'Juillet';
            case 8:
                return 'Août';
            case 9:
                return 'Septembre';
            case 10:
                return 'Octobre';
            case 11:
                return 'Novembre';
            case 12:
                return 'Décembre';
            default:
                return '';
        }
    }
}

